import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Control} from 'react-redux-form';

class CustomControl extends Component {
	render() {
		const {type, model, className, updateOn, ...rest} = this.props;

		return (
			<Control
				type={type}
				className={className}
				model={`.${model}`}
				updateOn={updateOn}
				{...rest}
			/>
		)
	}
}

CustomControl.defaultProps = {
	className: 'form-control',
	updateOn: 'blur'
};

CustomControl.propTypes = {
	type: PropTypes.string.isRequired,
	model: PropTypes.string.isRequired,
	className: PropTypes.string,
	updateOn: PropTypes.string
};

export default CustomControl;